import { render } from "./MonthDetail.vue?vue&type=template&id=87e0b650&scoped=true"
import script from "./MonthDetail.vue?vue&type=script&lang=js"
export * from "./MonthDetail.vue?vue&type=script&lang=js"

import "./MonthDetail.vue?vue&type=style&index=0&id=87e0b650&scoped=true&lang=css"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e0b650"]])

export default __exports__